export const AddressColumns = [
    "SNO",
    "SHIPTO",
    "BILLTO",
    "BUYERADDCRM",
    "DELIVERYADDCRM",
    "BillTo",
    "ShipTo",
    "BuyerCode",
    "BuyerAddress",
    "DeliveryAddress",
    "DeliveryCode"
]